import styled, { css } from "styled-components";
import { unitCalc } from "calcite-react/utils/helpers";

const Container = styled.div`
  margin: 0;
  margin-bottom: ${props => unitCalc(props.theme.baseline, 2, "/")};
  opacity: 1;
  ${(props) =>
    props.isRefreshing &&
    css`
      opacity: 0.3;
    `};
  
`;

export { Container };
